






















































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { useProducaoNaoCalculada } from '@/composables'

@Component
export default class ComponentIncluirNovasProducoes extends Vue {
  tableHeaders: any[] = [
    { text: 'Fonte Pagadora', value: 'fontePagadoraNome', align: 'left', sortable: false },
    { text: 'Prestador', value: 'prestadorNome', align: 'left', sortable: false },
  ]

  loadIncluirNovasProducoes: boolean = false

  get showModalIncluirNovasProducoes() { return this.getFinanceiroStore.modal.incluirNovasProducoes }
  set showModalIncluirNovasProducoes(value: boolean) { this.getFinanceiroStore.setModal({ name: 'incluirNovasProducoes', value }) }

  get loadingIncluirNovasProducoes() { return this.loadIncluirNovasProducoes }
  set loadingIncluirNovasProducoes(value: boolean) { this.loadIncluirNovasProducoes = value }

  async incluirNovasProducoes() {
    this.loadingIncluirNovasProducoes = true
    const response = await this.getFinanceiroStore.gerarRepasses()

    if (!response.success) {
      // FXSR-2984/2988 — quando toda a produção encontrada está bloqueada, response.message já
      // vem com o motivo explicativo do backend (repasse já liberado), em vez do genérico daqui.
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao atualizar o repasse.', 'error'))
      this.loadingIncluirNovasProducoes = false
      return
    }

    EventBus.$emit('setSnackbar', getSnackbarMessage('A atualização do repasse foi iniciada!', 'success'))
    const geracaoRepasseId = this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse
    await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(geracaoRepasseId)
    // FXSR-2984/2989 — invalida o cache do badge da listagem para esta geração (armadilha
    // conhecida: sem forceRefresh o número fica velho até a próxima navegação para a listagem).
    await useProducaoNaoCalculada.loadByGeracaoIds([geracaoRepasseId], { forceRefresh: true })
    this.showModalIncluirNovasProducoes = false
    this.loadingIncluirNovasProducoes = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
